var _circle, _path, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMetaCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Meta") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#0064E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.3,8 C4.3,6 5.6,5 7,6.3 C7.6,6.9 8,7.5 8,8 C8,7.5 8.4,6.9 9,6.3 C10.4,5 11.7,6 11.7,8 C11.7,10 10.4,11 9,9.7 C8.4,9.1 8,8.5 8,8 C8,8.5 7.6,9.1 7,9.7 C5.6,11 4.3,10 4.3,8 Z",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.85,
    fill: "none",
    stroke: "#000",
    strokeOpacity: 0.12,
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetaCircle);
export default __webpack_public_path__ + "static/media/meta-circle.d9e3a9879973c7c64e3c04ed0b4e77e1.svg";
export { ForwardRef as ReactComponent };